<style scoped>
	#app {
		padding: 10px 20px 20px 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.line {
		display: flex; flex-direction: row; flex-grow: 1; justify-content: space-between;
		margin-bottom: 20px;
	}
	.box1 {
		width: 24%; height: 280px; background-color: white;
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
		border-radius: 5px;
		display: flex;
		flex-direction: column;
	}
	.box4 {
		width: 360px; height: 290px; background-color: white;
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
		border-radius: 5px;
		display: flex;
		flex-direction: column;
	}
	.box3 {
		width: calc(100% - 380px); background-color: white;
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
		border-radius: 5px;
		display: flex;
		flex-direction: column;
	}
	.box2 {
		min-width: 400px;
		width: 49%; height: 280px; background-color: white;
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
		border-radius: 5px;
		margin-left: 10px;
		margin-right: 10px;
	}
	.box-header {
		border-bottom: solid 1px #F6F6F6;
		height: 60px;
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		text-indent: 20px;
	}
	.box-p {
		height: 280px; width: calc(100% - 370px); display: flex; flex-direction: row; justify-content: space-between;
	}
	.user-box {
		width: 100%;
		text-align: center;
		height: 120px;
		line-height: 120px;
		font-size: 28px;
		color: #1677FF;
		font-weight: bold;
	}
	.user-line {
		display: flex;
		flex-direction: row;
	}
	.user-col {
		width: 50%;
	}
	.user-item {
		text-align: center;
		line-height: 30px;
		font-size: 14px;
	}
	
	.tr {
		display: flex;
		flex-direction: row;
		border-bottom: solid 1px #F6F6F6;
	}
	.th {
		background-color: #FbFbFb;
		width: 25%;
		height: 50px;
		line-height: 50px;
		text-indent: 20px;
		font-weight: bold;
		font-size: 15px;
	}
	.td {
		width: 25%;
		height: 50px;
		line-height: 50px;
		text-indent: 20px;
		font-size: 14px;
	}
	.b {
		font-weight: bold;
	}
</style>
<template>
	<div id="app">
		<div style="width: 100%; text-align: center; height: 400px; display: flex; flex-direction: row; justify-content: center;
		align-items: center;">
			<div style="font-size: 38px; color: #666666;">健安集团·客服中心</div>
			
		</div>
	</div>
</template>

<script>
	
	
	
	export default {
		name:'Dashboard',
		data(){
			return {
			}
		},
		mounted() {
			this.$nextTick(() => {
			});
			
		},
		created() {
		},
		beforeDestroy() {
		},
		methods:{
			formatTimestamp(timestamp) {
				// 将时间戳转换为毫秒
				const date = new Date(timestamp * 1000);
				// 获取日期和时间的各个部分
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				// 格式化为字符串
				return `${year}-${month}-${day} ${hours}:${minutes}`;
			},
			refresh(){
				console.log("refresh click");
				this.getData();
			}
		}
	}
</script>

